import { Badge } from '@chain-zen/ui'

import type { ShipmentStatusEnum } from '../types/shipment'
import { getShipmentStatusColor } from '../utils/shipment'

/**
 * This component is used to display a dropdown to select team members for a shipment.
 * It allows the user to search for and select team members from the workspace.
 */
export const ShipmentStatusLabel = ({ status }: { status: ShipmentStatusEnum }) => {
  const config = getShipmentStatusColor(status)
  const displayStatus = status
    .replace(/_/g, ' ')
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

  return (
    <Badge variant="outline" className={`${config} border-0`}>
      {displayStatus}
    </Badge>
  )
}
